export const addServiceLabel = "Add Service";
export const editServiceLabel = "Edit Service";
export const ServiceName = "Service Name"
export const Description = "Description";
export const servicesLabel = "Services";
export const serviceLabel = "Service";
export const Cost = "Cost"
export const GstAmount = "Gst Amount";
export const WithGstAmount = "With Gst Amount";
export const servicesKey= "service_name"
export const costKey = "cost"
export const descriptonKey = "description";
export const hsnSacKey = "hsnSac.code";
export const gstKey = "gst";
export const gstAmountKey = "gst_amount";
export const amountKey = "with_gst_amount";
